<template>
  <div class="v-table__overflow">
    <table class="v-datatable v-table theme--light">
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column.value"
            :class="sortKey === column.value ? (sortOrders[column.value] > 0 ? 'asc' : 'desc') : 'column sortable'"
            :style="'cursor:pointer;'"
            @click="$emit('sort', column.value)" >
            <v-icon v-if="sortOrders[column.value] > 0" small>arrow_downward</v-icon>
            <v-icon v-else small>arrow_upward</v-icon>
              {{ column.text }}
          </th>
          <th v-if="detail_route && items.length > 0" :class="['column sortable']"> Detalle </th>
          <th v-if="edit_action && items.length > 0" :class="['column sortable']"> Editar </th>
          <th v-if="update_route && items.length > 0" :class="['column sortable']"> Editar </th>
          <th v-if="delete_action && items.length > 0" :class="['column sortable']"> Borrar </th>
        </tr>
      </thead>
      <slot></slot>
    </table>
  </div>
</template>

<script>
export default {
  props: ['columns', 'sortKey', 'sortOrders', 'detail_route', 'edit_action', 'update_route', 'delete_action', 'items']
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Datatable.vue